"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/internal_service.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalGoodsServiceGetAllGoodsByBrandResponse_Items = exports.InternalGoodsServiceGetAllGoodsByBrandResponse = exports.InternalGoodsServiceGetAllGoodsByBrandRequest = exports.InternalGoodsServiceGetGoodsVariantsResponse = exports.InternalGoodsServiceGetGoodsVariantsRequest = exports.InternalGoodsServiceGetGoodsVariantResponse = exports.InternalGoodsServiceCartItemVariant = exports.InternalGoodsServiceGetGoodsVariantRequest = exports.InternalGoodsServiceGetInventoryStatusResponse = exports.InternalGoodsServiceGetInventoryStatusRequest = exports.InternalGoodsServiceReleaseGoodsInventoryResponse = exports.InternalGoodsServiceReleaseGoodsInventoryRequest = exports.InternalGoodsServiceAllocateGoodsInventoryResponse = exports.InternalGoodsServiceAllocateGoodsInventoryRequest = exports.InternalGoodsInventoryStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const internal_common_pb_1 = require("./internal_common_pb");
/**
 * @generated from enum spwn.goods.v1.InternalGoodsInventoryStatus
 */
var InternalGoodsInventoryStatus;
(function (InternalGoodsInventoryStatus) {
    /**
     * @generated from enum value: INTERNAL_GOODS_INVENTORY_STATUS_UNSPECIFIED = 0;
     */
    InternalGoodsInventoryStatus[InternalGoodsInventoryStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 在庫がない
     *
     * @generated from enum value: INTERNAL_GOODS_INVENTORY_STATUS_OUT_OF_STOCK = 1;
     */
    InternalGoodsInventoryStatus[InternalGoodsInventoryStatus["OUT_OF_STOCK"] = 1] = "OUT_OF_STOCK";
    /**
     * 在庫がある
     *
     * @generated from enum value: INTERNAL_GOODS_INVENTORY_STATUS_IN_STOCK = 2;
     */
    InternalGoodsInventoryStatus[InternalGoodsInventoryStatus["IN_STOCK"] = 2] = "IN_STOCK";
    /**
     * 在庫確保できるグッズじゃない
     *
     * @generated from enum value: INTERNAL_GOODS_INVENTORY_STATUS_NOT_ALLOCATABLE = 3;
     */
    InternalGoodsInventoryStatus[InternalGoodsInventoryStatus["NOT_ALLOCATABLE"] = 3] = "NOT_ALLOCATABLE";
})(InternalGoodsInventoryStatus = exports.InternalGoodsInventoryStatus || (exports.InternalGoodsInventoryStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalGoodsInventoryStatus)
protobuf_1.proto3.util.setEnumType(InternalGoodsInventoryStatus, "spwn.goods.v1.InternalGoodsInventoryStatus", [
    { no: 0, name: "INTERNAL_GOODS_INVENTORY_STATUS_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_GOODS_INVENTORY_STATUS_OUT_OF_STOCK" },
    { no: 2, name: "INTERNAL_GOODS_INVENTORY_STATUS_IN_STOCK" },
    { no: 3, name: "INTERNAL_GOODS_INVENTORY_STATUS_NOT_ALLOCATABLE" },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceAllocateGoodsInventoryRequest
 */
class InternalGoodsServiceAllocateGoodsInventoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションID
         *
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * 確保したい在庫数
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceAllocateGoodsInventoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceAllocateGoodsInventoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceAllocateGoodsInventoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceAllocateGoodsInventoryRequest, a, b);
    }
}
exports.InternalGoodsServiceAllocateGoodsInventoryRequest = InternalGoodsServiceAllocateGoodsInventoryRequest;
InternalGoodsServiceAllocateGoodsInventoryRequest.runtime = protobuf_1.proto3;
InternalGoodsServiceAllocateGoodsInventoryRequest.typeName = "spwn.goods.v1.InternalGoodsServiceAllocateGoodsInventoryRequest";
InternalGoodsServiceAllocateGoodsInventoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceAllocateGoodsInventoryResponse
 */
class InternalGoodsServiceAllocateGoodsInventoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションID
         *
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceAllocateGoodsInventoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceAllocateGoodsInventoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceAllocateGoodsInventoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceAllocateGoodsInventoryResponse, a, b);
    }
}
exports.InternalGoodsServiceAllocateGoodsInventoryResponse = InternalGoodsServiceAllocateGoodsInventoryResponse;
InternalGoodsServiceAllocateGoodsInventoryResponse.runtime = protobuf_1.proto3;
InternalGoodsServiceAllocateGoodsInventoryResponse.typeName = "spwn.goods.v1.InternalGoodsServiceAllocateGoodsInventoryResponse";
InternalGoodsServiceAllocateGoodsInventoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceReleaseGoodsInventoryRequest
 */
class InternalGoodsServiceReleaseGoodsInventoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションID
         *
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * 解放したい在庫数
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceReleaseGoodsInventoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceReleaseGoodsInventoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceReleaseGoodsInventoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceReleaseGoodsInventoryRequest, a, b);
    }
}
exports.InternalGoodsServiceReleaseGoodsInventoryRequest = InternalGoodsServiceReleaseGoodsInventoryRequest;
InternalGoodsServiceReleaseGoodsInventoryRequest.runtime = protobuf_1.proto3;
InternalGoodsServiceReleaseGoodsInventoryRequest.typeName = "spwn.goods.v1.InternalGoodsServiceReleaseGoodsInventoryRequest";
InternalGoodsServiceReleaseGoodsInventoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceReleaseGoodsInventoryResponse
 */
class InternalGoodsServiceReleaseGoodsInventoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションID
         *
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * 最新のバリエーションの在庫数
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceReleaseGoodsInventoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceReleaseGoodsInventoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceReleaseGoodsInventoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceReleaseGoodsInventoryResponse, a, b);
    }
}
exports.InternalGoodsServiceReleaseGoodsInventoryResponse = InternalGoodsServiceReleaseGoodsInventoryResponse;
InternalGoodsServiceReleaseGoodsInventoryResponse.runtime = protobuf_1.proto3;
InternalGoodsServiceReleaseGoodsInventoryResponse.typeName = "spwn.goods.v1.InternalGoodsServiceReleaseGoodsInventoryResponse";
InternalGoodsServiceReleaseGoodsInventoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetInventoryStatusRequest
 */
class InternalGoodsServiceGetInventoryStatusRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリエーションID
         *
         * @generated from field: string variant_id = 1;
         */
        this.variantId = "";
        /**
         * 指定された数量で在庫があるか確認する
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetInventoryStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetInventoryStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetInventoryStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetInventoryStatusRequest, a, b);
    }
}
exports.InternalGoodsServiceGetInventoryStatusRequest = InternalGoodsServiceGetInventoryStatusRequest;
InternalGoodsServiceGetInventoryStatusRequest.runtime = protobuf_1.proto3;
InternalGoodsServiceGetInventoryStatusRequest.typeName = "spwn.goods.v1.InternalGoodsServiceGetInventoryStatusRequest";
InternalGoodsServiceGetInventoryStatusRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetInventoryStatusResponse
 */
class InternalGoodsServiceGetInventoryStatusResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定された在庫が確保できるか
         *
         * @generated from field: spwn.goods.v1.InternalGoodsInventoryStatus status = 1;
         */
        this.status = InternalGoodsInventoryStatus.UNSPECIFIED;
        /**
         * バリエーションID
         *
         * @generated from field: string variant_id = 2;
         */
        this.variantId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetInventoryStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetInventoryStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetInventoryStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetInventoryStatusResponse, a, b);
    }
}
exports.InternalGoodsServiceGetInventoryStatusResponse = InternalGoodsServiceGetInventoryStatusResponse;
InternalGoodsServiceGetInventoryStatusResponse.runtime = protobuf_1.proto3;
InternalGoodsServiceGetInventoryStatusResponse.typeName = "spwn.goods.v1.InternalGoodsServiceGetInventoryStatusResponse";
InternalGoodsServiceGetInventoryStatusResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalGoodsInventoryStatus) },
    { no: 2, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetGoodsVariantRequest
 */
class InternalGoodsServiceGetGoodsVariantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetGoodsVariantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetGoodsVariantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetGoodsVariantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetGoodsVariantRequest, a, b);
    }
}
exports.InternalGoodsServiceGetGoodsVariantRequest = InternalGoodsServiceGetGoodsVariantRequest;
InternalGoodsServiceGetGoodsVariantRequest.runtime = protobuf_1.proto3;
InternalGoodsServiceGetGoodsVariantRequest.typeName = "spwn.goods.v1.InternalGoodsServiceGetGoodsVariantRequest";
InternalGoodsServiceGetGoodsVariantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceCartItemVariant
 */
class InternalGoodsServiceCartItemVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceCartItemVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceCartItemVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceCartItemVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceCartItemVariant, a, b);
    }
}
exports.InternalGoodsServiceCartItemVariant = InternalGoodsServiceCartItemVariant;
InternalGoodsServiceCartItemVariant.runtime = protobuf_1.proto3;
InternalGoodsServiceCartItemVariant.typeName = "spwn.goods.v1.InternalGoodsServiceCartItemVariant";
InternalGoodsServiceCartItemVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: internal_common_pb_1.InternalGoods },
    { no: 2, name: "variant", kind: "message", T: internal_common_pb_1.InternalGoodsVariant },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetGoodsVariantResponse
 */
class InternalGoodsServiceGetGoodsVariantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetGoodsVariantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetGoodsVariantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetGoodsVariantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetGoodsVariantResponse, a, b);
    }
}
exports.InternalGoodsServiceGetGoodsVariantResponse = InternalGoodsServiceGetGoodsVariantResponse;
InternalGoodsServiceGetGoodsVariantResponse.runtime = protobuf_1.proto3;
InternalGoodsServiceGetGoodsVariantResponse.typeName = "spwn.goods.v1.InternalGoodsServiceGetGoodsVariantResponse";
InternalGoodsServiceGetGoodsVariantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variant", kind: "message", T: InternalGoodsServiceCartItemVariant },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetGoodsVariantsRequest
 */
class InternalGoodsServiceGetGoodsVariantsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string goods_variant_ids = 1;
         */
        this.goodsVariantIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetGoodsVariantsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetGoodsVariantsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetGoodsVariantsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetGoodsVariantsRequest, a, b);
    }
}
exports.InternalGoodsServiceGetGoodsVariantsRequest = InternalGoodsServiceGetGoodsVariantsRequest;
InternalGoodsServiceGetGoodsVariantsRequest.runtime = protobuf_1.proto3;
InternalGoodsServiceGetGoodsVariantsRequest.typeName = "spwn.goods.v1.InternalGoodsServiceGetGoodsVariantsRequest";
InternalGoodsServiceGetGoodsVariantsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetGoodsVariantsResponse
 */
class InternalGoodsServiceGetGoodsVariantsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.InternalGoodsServiceCartItemVariant variants = 1;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetGoodsVariantsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetGoodsVariantsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetGoodsVariantsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetGoodsVariantsResponse, a, b);
    }
}
exports.InternalGoodsServiceGetGoodsVariantsResponse = InternalGoodsServiceGetGoodsVariantsResponse;
InternalGoodsServiceGetGoodsVariantsResponse.runtime = protobuf_1.proto3;
InternalGoodsServiceGetGoodsVariantsResponse.typeName = "spwn.goods.v1.InternalGoodsServiceGetGoodsVariantsResponse";
InternalGoodsServiceGetGoodsVariantsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variants", kind: "message", T: InternalGoodsServiceCartItemVariant, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandRequest
 */
class InternalGoodsServiceGetAllGoodsByBrandRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: repeated spwn.goods.v1.InternalGoodsStatus status = 2;
         */
        this.status = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetAllGoodsByBrandRequest, a, b);
    }
}
exports.InternalGoodsServiceGetAllGoodsByBrandRequest = InternalGoodsServiceGetAllGoodsByBrandRequest;
InternalGoodsServiceGetAllGoodsByBrandRequest.runtime = protobuf_1.proto3;
InternalGoodsServiceGetAllGoodsByBrandRequest.typeName = "spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandRequest";
InternalGoodsServiceGetAllGoodsByBrandRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(internal_common_pb_1.InternalGoodsStatus), repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandResponse
 */
class InternalGoodsServiceGetAllGoodsByBrandResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandResponse.Items items = 1;
         */
        this.items = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetAllGoodsByBrandResponse, a, b);
    }
}
exports.InternalGoodsServiceGetAllGoodsByBrandResponse = InternalGoodsServiceGetAllGoodsByBrandResponse;
InternalGoodsServiceGetAllGoodsByBrandResponse.runtime = protobuf_1.proto3;
InternalGoodsServiceGetAllGoodsByBrandResponse.typeName = "spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandResponse";
InternalGoodsServiceGetAllGoodsByBrandResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: InternalGoodsServiceGetAllGoodsByBrandResponse_Items, repeated: true },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandResponse.Items
 */
class InternalGoodsServiceGetAllGoodsByBrandResponse_Items extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズのバリアント
         *
         * @generated from field: repeated spwn.goods.v1.InternalGoodsVariant variants = 2;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandResponse_Items().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandResponse_Items().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsServiceGetAllGoodsByBrandResponse_Items().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsServiceGetAllGoodsByBrandResponse_Items, a, b);
    }
}
exports.InternalGoodsServiceGetAllGoodsByBrandResponse_Items = InternalGoodsServiceGetAllGoodsByBrandResponse_Items;
InternalGoodsServiceGetAllGoodsByBrandResponse_Items.runtime = protobuf_1.proto3;
InternalGoodsServiceGetAllGoodsByBrandResponse_Items.typeName = "spwn.goods.v1.InternalGoodsServiceGetAllGoodsByBrandResponse.Items";
InternalGoodsServiceGetAllGoodsByBrandResponse_Items.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: internal_common_pb_1.InternalGoods },
    { no: 2, name: "variants", kind: "message", T: internal_common_pb_1.InternalGoodsVariant, repeated: true },
    { no: 3, name: "purchase_status", kind: "enum", T: protobuf_1.proto3.getEnumType(internal_common_pb_1.InternalGoodsPurchaseStatus), opt: true },
]);
//# sourceMappingURL=internal_service_pb.js.map